module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "center-block"
  }, [_c('div', [_c('div', {
    staticClass: "box",
    staticStyle: {
      "padding": "50px"
    }
  }, [_c('div', {
    staticClass: "warning-info"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" "), _c('span', [_vm._v("\n              「現折活動」與其他優惠活動併用規則請\n              "), _c('a', {
    attrs: {
      "href": "https://docs.google.com/spreadsheets/d/1_nFqJPrfvsNEvTXBTHKeSrm9oYwJc4-BPFK6ocBo-bg/edit#gid=0",
      "target": "_blank",
      "rel": "noopener noreferrer"
    },
    domProps: {
      "textContent": _vm._s('點我開啟')
    }
  }), _vm._v("。\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.list), function(item, index) {
    return [_c('div', {
      key: 'index' + index,
      class: ['col-md-6']
    }, [_c('div', {
      class: ['info-block', ("bg-light-" + (item.color))]
    }, [_c('div', {
      class: [("bg-" + (item.color)), 'order-block text-center title subNumber']
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('div', {
      class: ['discount-block', ("bg-light-" + (item.color))]
    }, [_c('div', {
      staticClass: "flex discount-inside-block"
    }, [_c('div', [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "desciption"
    }, [_vm._v(_vm._s(item.desciption))])]), _vm._v(" "), _c('div', {
      staticClass: "edit-block"
    }, [_c('router-link', {
      attrs: {
        "to": '/crDiscount?rule_code=' + item.link
      }
    }, [_c('button', {
      staticClass: "btn btn-black"
    }, [_vm._v("新增")])])], 1)])])])])]
  })], 2)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("請選擇欲建立的折扣類型，按下新增後進入編輯。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("若同時有兩檔現折活動，訂單若同時符合條件，會以先設定的現折活動為優先套用（消費者不可選擇）。")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f7527ee"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Discount/ChooseDiscount.vue
// module id = 2501
// module chunks = 1